import { type JSX } from 'react';
import { uniq } from 'ramda';
import { ISuggestion } from '../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import EDBox from '../../../../../../BaseComponents/EDBox/EDBox';
import { kodplaner_ekkodplaner } from '../../../../../../Components/KodplanManager/Queries/_QueryTypes/kodplaner';
import { NodeUrvalQuery_node_TEDSelection } from '../../../../../../Components/Urval/Components/SavedUrval/Queries/NodeUrvalQuery/_QueryTypes/NodeUrvalQuery';
import { convertUrval } from '../../../../../../Components/Urval/Components/SavedUrval/Utils/convertSavedUrval';
import { EK_KONTO_URVAL_COLLECTION_NAME } from '../../../../../../Components/Urval/Consts/UrvalConsts';
import {
  TEDEKBokforderOMFORINGSTYPEnum,
  TEDEKBokforderRadPERIODISERADEnum,
  TEDEKBokforderSTATUSEnum,
  TEDEKBokforderTYPEnum,
  TEDEKBokforderU_UTBETALNINGSKATEGORIEnum,
  TEDEKBokforderVariantEnum,
  TEDEKBokforingsmallParamPARAM_DATATYPEnum,
  TEDEKBokforingsmallRadMALL_TYP_1Enum,
  TEDEKBokfverVERKAT_KODEnum,
  TEDEKKontodelREDOVISN_TYPEnum,
  TEDEKLokalKontoanvandningMALL_TYPEnum,
} from '../../../../../../globalQueryTypes';
import { getKodplanByYear } from '../../../../../../Model/ModelContext/KodplanUtils';
import { AvenyCollectionMap } from '../../../../../../Model/ModelContext/ModelContext';
import {
  IColumnDef,
  ICustomValidValues,
} from '../../../../../../Types/ColumnDefType';
import mergeSort, { numberCompare } from '../../../../../../Utils/mergeSort';
import {
  DisabledType,
  IEditMenuActionParams,
  IFormData,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import {
  FormUpdateAssociatonType,
  getFormUpdateValue,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { IBokforderKodbehorigheter } from '../../../../_Common/Components/KonteringManager/KonteringContext';
import {
  IKodstrang,
  IKodstrangDel,
} from '../../../../_Common/Components/KonteringManager/KonteringManager';
import {
  IKontodel,
  IKontodelDef,
} from '../../../../_Common/Components/KonteringManager/Query/KonteringManagerQuery';
import { IAssociationConfig } from '../../../../_Common/Const/BusinessConfigs';
import { filterKodBehOnKoddel } from '../../../../_Common/Utils/kodbehorighetUtils';
import {
  DefaultBfoVariantEnum,
  IParamValues,
  ITemplateKoddel,
  ITemplateRow,
  IUserBokforderKodbehorigheter,
} from '../Components/BokforderContext/BokforderContextManager';
import {
  createKodstrang,
  createKodstrangDelar,
} from '../Hooks/useValidateBokforder';
import { UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter } from '../Queries/BokforderKodbehorigheter/_QueryTypes/UserBokforderKodbehorigheterQuery';
import { BokforderSettingsQuery_db_EKBokforingsmall_All__Associations_Rader_All } from '../Queries/BokforderSettingsQuery/_QueryTypes/BokforderSettingsQuery';
import { BokforderQuery_node_TEDEKBokforder__Associations_Rader } from '../Queries/_QueryTypes/BokforderQuery';
import {
  BokforderType__Associations_Rader,
  BokforderType__Associations_Rader__Associations,
  BokforderType__Associations_Rader__Associations_Attestant__Associations_Franvaro_All,
  BokforderType__Associations_Rader__Associations_Kontodel1,
} from '../Queries/_QueryTypes/BokforderType';
import {
  filterInternalAndExternalKoddelar,
  filterKontodelInKombinationsvilkor,
  filterOnTemplateRowValidInterval,
  getAllKombinationNonValidOrdningsNr,
} from './filterValidKoddelar';
import { isInternkontoEnum } from './validationUtils';
import { KonteringUtils } from '../../../../_Common/Components/KonteringManager/KonteringManagerUtils';
import { roundToTwoDecimals } from '../../../../Leverantor/ObjektVyer/FakturaDel/Components/Kontering/Utils/KonteringUtils';
import { UtanordningType__Associations_Rader } from '../Queries/_QueryTypes/UtanordningType';
import { mergeBusinessDataMutations } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/MergeBusinessDataMutations';
import { KonteringsmallQuery } from '../Components/BokforderCreateDialog/Queries/_QueryTypes/KonteringsmallQuery';
import { FranvaroReservForQuery_db_SYSFranvaro_All } from '../../../../SystemAdministration/ObjektVyer/User/Components/FranvaroReservFor/Queries/_QueryTypes/FranvaroReservForQuery';
import { inDateInterval } from '../../../../../../Utils/utils';
import { NEWLY_ADDED_ID_PREFIX_FOR_UPDATE } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Const/BusinessDataFormConst';

export enum RemoveObjectAction {
  EMPTY = 'EMPTY',
  UNFULLFILLED = 'UNFULLFILLED',
}

export interface IFranvaroUserOption {
  id: string;
  Fullname: string | null;
  SIGNATURE: string;
  Attesterat: boolean;
  AttesteratAsCurrentReserv: boolean;
}

interface IGetAttestantStringObject {
  Attestant: string | null | undefined;
  ReservList: string[];
  Reserv: string | null | undefined;
  DATUM: any;
}

export const createParamString = (paramValues: IParamValues) => {
  let text = '';

  for (const [key, value] of Object.entries(paramValues)) {
    text += `${key}=${value};`;
  }
  return text;
};

export const createLabelText = (
  templateText: string,
  paramValues: IParamValues
) => {
  let newTemplateText = templateText;

  for (const [key, value] of Object.entries(paramValues)) {
    newTemplateText = newTemplateText.replace(`[${key}]`, value);
  }
  newTemplateText = newTemplateText.replaceAll(/\[.*\]/gi, '');
  return newTemplateText;
};

export const getKodplanForBokfOrder = (
  kodplaner: kodplaner_ekkodplaner[],
  bokfdate: Date
): kodplaner_ekkodplaner | undefined => {
  const year = bokfdate.getFullYear();
  return getKodplanByYear(kodplaner, year);
};

export const isBokfOrderKontodelValid = (
  kontodel: IKontodel,
  bokfDate: Date,
  isInternKonto: isInternkontoEnum
): boolean => {
  let useInternKonto: boolean | null = null;

  switch (isInternKonto) {
    case isInternkontoEnum.True:
      useInternKonto = true;
      break;
    case isInternkontoEnum.False:
      useInternKonto = false;
      break;

    default:
      break;
  }

  if (useInternKonto !== null) {
    return (
      kontodel.aktiv &&
      kontodel.internKonto === useInternKonto &&
      !kontodel.rubrikKonto &&
      !kontodel.budgetKonto &&
      kontodel.franDatum <= bokfDate &&
      kontodel.tillDatum >= bokfDate &&
      !kontodel.sparraManuell
    );
  } else {
    return (
      kontodel.aktiv &&
      !kontodel.rubrikKonto &&
      !kontodel.budgetKonto &&
      kontodel.franDatum <= bokfDate &&
      kontodel.tillDatum >= bokfDate &&
      !kontodel.sparraManuell
    );
  }
};

export const createKodstrangDelarFromRow = (
  rowAssoc: {
    Kontodel1: { id: string } | null;
    Kontodel2: { id: string } | null;
    Kontodel3: { id: string } | null;
    Kontodel4: { id: string } | null;
    Kontodel5: { id: string } | null;
    Kontodel6: { id: string } | null;
    Kontodel7: { id: string } | null;
    Kontodel8: { id: string } | null;
    Kontodel9: { id: string } | null;
    Kontodel10: { id: string } | null;
  } | null,
  kontodelDefs: IKontodelDef[]
): IKodstrangDel[] => {
  let kontodelarInKodstrang: IKodstrangDel[] = [];
  if (rowAssoc) {
    for (const [key, value] of Object.entries(rowAssoc)) {
      if (key.includes('Kontodel') && value) {
        kontodelarInKodstrang = kontodelarInKodstrang.concat(
          (kontodelarInKodstrang = createKodstrangDelar(
            key,
            kontodelDefs,
            value
          ))
        );
      }
    }
  }
  kontodelarInKodstrang = mergeSort(
    kontodelarInKodstrang,
    (a, b) => a.ordningsNr - b.ordningsNr
  );

  return kontodelarInKodstrang;
};

export const createKodstrangFromRow = (
  row: {
    id: string;
    Debet: string | null;
    Kredit: string | null;
  },
  kontodelarInKodstrang: IKodstrangDel[]
): IKodstrang => {
  const belopp = row.Debet
    ? row.Debet
      ? parseInt(row.Debet)
      : 0
    : row.Kredit
    ? parseInt(row.Kredit)
    : 0;

  const kodstrang: IKodstrang = {
    id: row.id,
    belopp: belopp,
    kontodelar: kontodelarInKodstrang,
  };
  return kodstrang;
};

export const filterUsersOnKodstrang = (
  kontodelarInKodstrang: IKodstrangDel[]
) => {
  return (user: IUserBokforderKodbehorigheter) => {
    let isKodstrangOk = false;
    for (
      let index = 0;
      index < user.bokforderKodbehorighetUrval.length;
      index++
    ) {
      const kodbeh = user.bokforderKodbehorighetUrval[index];

      isKodstrangOk = kontodelarInKodstrang.every(koddel => {
        const result = filterKodBehOnKoddel(koddel, kodbeh.urval);
        return result;
      });

      if (isKodstrangOk) {
        break;
      }
    }
    return isKodstrangOk;
  };
};

export const getUserKodbehsBasedOnKodstrang = (
  kodstrangar: IKodstrang[],
  user: IUserBokforderKodbehorigheter
): IBokforderKodbehorigheter[] => {
  const newUserKodbehs: IBokforderKodbehorigheter[] = [];

  for (
    let index = 0;
    index < user.bokforderKodbehorighetUrval.length;
    index++
  ) {
    const kodbeh: IBokforderKodbehorigheter =
      user.bokforderKodbehorighetUrval[index];

    const kodbehIsOKForEveryKodstrang = kodstrangar.every(kodstrang =>
      kodstrang.kontodelar.every((koddel: IKodstrangDel) => {
        const result = filterKodBehOnKoddel(koddel, kodbeh.urval);
        return result;
      })
    );

    if (kodbehIsOKForEveryKodstrang) {
      newUserKodbehs.push(kodbeh);
    }
  }

  return newUserKodbehs;
};

const getValidAttestantOptions = (
  allUsers: IUserBokforderKodbehorigheter[],
  kontodelDefs: IKontodelDef[]
): ICustomValidValues => {
  const result: ICustomValidValues = {
    validValuesFunction: (defaultValues, formState) => {
      const row = formState.currentValues as BokforderType__Associations_Rader;
      const rowAssoc = row?._Associations;

      let kontodelarInKodstrang: IKodstrangDel[] = createKodstrangDelarFromRow(
        rowAssoc,
        kontodelDefs
      );

      let result: IUserBokforderKodbehorigheter[] = allUsers;
      if (kontodelarInKodstrang.length > 0) {
        result = allUsers.filter(filterUsersOnKodstrang(kontodelarInKodstrang));
      }

      const resultSuggestions =
        result.map(user => {
          const attestantOption: ISuggestion = {
            name: user.namn ?? 'Saknar namn',
            value: user.userID,
            data: {
              Name: user.namn ?? 'Saknar namn',
              id: user.userID,
            },
          };
          return attestantOption;
        }) ?? [];

      return resultSuggestions;
    },
    skipDefaultValues: true,
  };

  return result;
};

export const getSelectedBaskontoInternKontoValue = (
  selectedBaskonto: BokforderType__Associations_Rader__Associations_Kontodel1,
  baskontoDelsDef: IKontodelDef | undefined
): boolean | undefined => {
  let selectedBaskontoId = '';
  if (typeof selectedBaskonto === 'string') {
    selectedBaskontoId = selectedBaskonto;
  } else if (
    typeof selectedBaskonto === 'object' &&
    selectedBaskonto !== null
  ) {
    selectedBaskontoId = selectedBaskonto.id;
  } else {
    return;
  }
  const baskontoDetailed = baskontoDelsDef?.kontodelar.find(
    baskontoFromKodplan => baskontoFromKodplan.id === selectedBaskontoId
  );

  return baskontoDetailed?.internKonto;
};

const getValidKontodelOptions = (
  bokfDate: Date,
  activekontodelDef: IKontodelDef,
  allKontodelDefs: IKontodelDef[],
  bokforderKodplanId: string,
  konteringUtils: KonteringUtils,
  templateRows: ITemplateRow[],
  validRedovisningsTypList: TEDEKKontodelREDOVISN_TYPEnum[] | undefined,
  bokforderContextKonteringsmallarData: KonteringsmallQuery | undefined
): ICustomValidValues => {
  const konteringsmallsBaskontoID =
    bokforderContextKonteringsmallarData?.ekkonteringsmall?.Kontodel1?.id;

  const result: ICustomValidValues = {
    validValuesFunction: (defaultValues, formState, parentFormState) => {
      let result: ISuggestion[] = [];

      const kontoplan = konteringUtils.getKontoPlanById(bokforderKodplanId);

      const rows: BokforderType__Associations_Rader[] =
        parentFormState?.currentValues?._Associations?.Rader;

      const currentRow = rows?.find(
        row => row.id === formState.currentValues?.id
      );

      const currentTemplateRow = templateRows.find(
        templateRow => templateRow.id === currentRow?.id
      );
      let currentTemplateKontodel: ITemplateKoddel | undefined = undefined;
      for (const [key, value] of Object.entries(
        currentTemplateRow?.kontodelar ?? {}
      )) {
        if (key.includes(activekontodelDef.ordningsNr.toString())) {
          currentTemplateKontodel = value;
          break;
        }
      }

      const potentialBaskontonInBokforder: BokforderType__Associations_Rader__Associations_Kontodel1[] =
        parentFormState?.currentValues?._Associations?.Rader?.map(
          (rad: BokforderType__Associations_Rader) =>
            rad._Associations?.Kontodel1
        );

      // Filtrera bort null-värden
      const selectedBaskontonInBokforder =
        potentialBaskontonInBokforder?.filter(
          potentialKoddel => potentialKoddel
        );

      let enhancedSelectedKontodelar: IKontodel[] | undefined;

      if (currentRow) {
        const nonValidOrdningsNr = getAllKombinationNonValidOrdningsNr(
          allKontodelDefs,
          bokfDate,
          currentRow
        );

        // Får ej kombinera med någon givet baskonto
        if (nonValidOrdningsNr.includes(activekontodelDef.ordningsNr)) {
          return [];
        }

        const kodstrangar = createKodstrang(currentRow, allKontodelDefs);

        enhancedSelectedKontodelar = kodstrangar?.kontodelar.reduce<IKontodel[]>(
          (prevKontodelArray, kontodel) => {
            if (!kontodel) {
              return prevKontodelArray;
            }
            const enhancedKontodel = konteringUtils.getKontodelByKontodel(
              kontoplan?.id ?? '',
              kontodel.ordningsNr,
              kontodel.kontodel,
              bokfDate
            );
            if (enhancedKontodel) {
              return [...prevKontodelArray, enhancedKontodel];
            } else {
              return prevKontodelArray;
            }
          },
          []
        );
      }

      //Filtrera fram koddelar som är ok enligt våra filtreringsregler
      result = activekontodelDef.kontodelar.reduce<ISuggestion<string>[]>(
        (prevKontodelArray, kontodel) => {
          //Kolla i om kontodel är inom intervallet för mallraden
          const validKontodelInTemplateRowInterval = currentTemplateKontodel
            ?.options.validInterval
            ? filterOnTemplateRowValidInterval(
                kontodel,
                currentTemplateKontodel
              )
            : true;

          //Hantera när en mallrad har en förvald koddel
          const validKontodelinTemplateRow =
            currentTemplateKontodel?.kontodel?.KONTODEL === undefined
              ? true
              : currentTemplateKontodel?.kontodel?.KONTODEL ===
                kontodel.kontodel
              ? true
              : false;

          const validInternalExternalSuggestion =
            filterInternalAndExternalKoddelar(
              selectedBaskontonInBokforder,
              activekontodelDef,
              kontodel,
              bokfDate
            );

          // Kolla så att koddelen är inom någon av de andras kodelar kombinationsvilkor
          const validKombVillkorSuggestion = filterKontodelInKombinationsvilkor(
            enhancedSelectedKontodelar,
            kontodel
          );

          const validRedovisningsTyp =
            validRedovisningsTypList && activekontodelDef.ordningsNr === 1
              ? validRedovisningsTypList.some(
                  validRedovisningsTyp =>
                    validRedovisningsTyp === kontodel.redovisningsTyp
                )
              : true;

          if (
            (validInternalExternalSuggestion &&
              validKombVillkorSuggestion &&
              validKontodelInTemplateRowInterval &&
              validKontodelinTemplateRow &&
              validRedovisningsTyp) ||
            konteringsmallsBaskontoID === kontodel.id
          ) {
            const suggestion: ISuggestion = {
              name: `${kontodel.kontodel} - ${kontodel.benamning}`,
              value: kontodel.id,
              data: {
                BENAMNING: kontodel.benamning,
                KONTODEL: kontodel.kontodel,
                KontodelBenamning: `${kontodel.kontodel} - ${kontodel.benamning}`,
                id: kontodel.id,
              },
            };
            return [...prevKontodelArray, suggestion];
          }
          return prevKontodelArray;
        },
        []
      );

      return result;
    },
    skipDefaultValues: true,
    useParentFormState: true,
  };

  return result;
};

export const getUsedKontodelarByBokforder = (
  rows: BokforderType__Associations_Rader[] = []
) => {
  return rows.reduce((prev, curr) => {
    const rowKontodelar = [];

    if (curr._Associations) {
      for (const [key, value] of Object.entries(curr._Associations)) {
        if (key.includes('Kontodel') && value && !prev.includes(key)) {
          rowKontodelar.push(key);
        }
      }
    }

    return [...rowKontodelar, ...prev];
  }, [] as string[]);
};

export const getBokforderCustomColumns = (
  allKontodelDefs: IKontodelDef[],
  bokfDate: Date,
  allUsers: IUserBokforderKodbehorigheter[],
  disableEditMode: boolean,
  bokforderKodplanId: string,
  konteringUtils: KonteringUtils,
  templateRows: ITemplateRow[],
  usedKontodelar: string[],
  rowHasReserv: boolean,
  hideKredit?: boolean,
  debetCaption?: string,
  validRedovisningsTypList?: TEDEKKontodelREDOVISN_TYPEnum[],
  showAttestantKonteraSwitch?: boolean,
  bokforderContextKonteringsmallarData?: KonteringsmallQuery
): IColumnDef[] => {
  const result: IColumnDef[] = [];

  for (let index = 0; index < allKontodelDefs.length; index++) {
    //kontodelDef för given kolumn
    const kontodelDef = allKontodelDefs[index];
    if (
      kontodelDef.visibleFromDate <= bokfDate &&
      kontodelDef.visibleToDate >= bokfDate
    ) {
      if (
        disableEditMode &&
        !usedKontodelar.includes('Kontodel' + kontodelDef.ordningsNr)
      ) {
        continue;
      }

      const ordningsNr = kontodelDef.ordningsNr;

      const columnDefinition: IColumnDef = {
        association: `Kontodel${ordningsNr}`,
        attributeDef: 'KontodelBenamning',
        caption: kontodelDef.namn,
        customValidValues: getValidKontodelOptions(
          bokfDate,
          kontodelDef,
          allKontodelDefs,
          bokforderKodplanId,
          konteringUtils,
          templateRows,
          validRedovisningsTypList,
          bokforderContextKonteringsmallarData
        ),
        disableEditMode: disableEditMode,
      };
      result.push(columnDefinition);
    }
  }
  result.push({
    attributeDef: 'DEBET',
    disableEditMode: disableEditMode,
    caption: debetCaption !== '' ? debetCaption : undefined,
  });
  if (!hideKredit) {
    result.push({
      attributeDef: 'KREDIT',
      disableEditMode: disableEditMode,
    });
  }
  result.push({
    attributeDef: 'TEXT',
    size: 'large',
    disableEditMode: !showAttestantKonteraSwitch ? false : disableEditMode,
  });
  result.push({
    association: 'Attestant',
    attributeDef: 'Name',
    customValidValues: getValidAttestantOptions(allUsers, allKontodelDefs),
    disableEditMode: !showAttestantKonteraSwitch ? false : disableEditMode,
  });
  if (rowHasReserv) {
    result.push({
      association: 'Reserv',
      attributeDef: 'Name',
      disableEditMode: true,
    });
  }

  return result;
};

export const paramIsDateType = (
  param: TEDEKBokforingsmallParamPARAM_DATATYPEnum | null
) => {
  switch (param) {
    case TEDEKBokforingsmallParamPARAM_DATATYPEnum.DATUM__AAAA_MM_DD_:
      return true;

    default:
      return false;
  }
};

export const getKontodelCustomConfigs = (
  kontodelDefs: IKontodelDef[]
): { [associationName: string]: IAssociationConfig } => {
  const result = kontodelDefs.reduce((prev, currValue) => {
    return {
      ...prev,
      [`Kontodel${currValue.ordningsNr}`]: { disableArrowIcon: true },
    };
  }, {});

  return result;
};

export const isRowEmpty = (
  row: BokforderType__Associations_Rader | UtanordningType__Associations_Rader,
  ignoreDebetAndKredit = true
) => {
  let result = false;

  if (Object.keys(row).length > 0) {
    // Plocka ut relevanta fält från raden
    let pickedValues = {};

    if (ignoreDebetAndKredit) {
      pickedValues = (({ TEXT, _Associations }) => ({
        TEXT,
        _Associations,
      }))(row);
    } else {
      pickedValues = (({ KREDIT, DEBET, TEXT, _Associations }) => ({
        KREDIT,
        DEBET,
        TEXT,
        _Associations,
      }))(row);
    }

    // Kolla om DEBET,KREDIT, TEXT eller kontodel och Attestant är tomma
    result = Object.values(pickedValues).every(rowValue => {
      if (typeof rowValue === 'object' && rowValue !== null) {
        return Object.entries(rowValue).every(
          (assocValue: [string, string]) => {
            if (
              !(
                assocValue[0].includes('Kontodel') ||
                assocValue[0].includes('Attestant')
              ) ||
              assocValue[1] === null
            ) {
              return true;
            } else {
              return false;
            }
          }
        );
      }

      if (rowValue === undefined || rowValue === null || rowValue === '') {
        return true;
      } else {
        return false;
      }
    });
  }

  return result;
};

const getLocalUsageEnumFromBokforderMall = (
  MALL_TYP_1: TEDEKBokforingsmallRadMALL_TYP_1Enum | null
) => {
  switch (MALL_TYP_1) {
    case TEDEKBokforingsmallRadMALL_TYP_1Enum.BANK_KONTANT:
      return TEDEKLokalKontoanvandningMALL_TYPEnum.BANK_KONTANT;
    case TEDEKBokforingsmallRadMALL_TYP_1Enum.KASSA_KONTANT:
      return TEDEKLokalKontoanvandningMALL_TYPEnum.KASSA_KONTANT;
    case TEDEKBokforingsmallRadMALL_TYP_1Enum.KORT:
      return TEDEKLokalKontoanvandningMALL_TYPEnum.KORT;
    case TEDEKBokforingsmallRadMALL_TYP_1Enum.SKAP_KONTANT:
      return TEDEKLokalKontoanvandningMALL_TYPEnum.SKAP_KONTANT;
    case TEDEKBokforingsmallRadMALL_TYP_1Enum.SWISH:
      return TEDEKLokalKontoanvandningMALL_TYPEnum.SWISH;

    default:
      return null;
  }
};

export const findKontodelWithLocalusage =
  (
    row: BokforderSettingsQuery_db_EKBokforingsmall_All__Associations_Rader_All
  ) =>
  (kontodel: IKontodel) =>
    kontodel.localUsage?.some(localUsage => {
      const translatedValue = getLocalUsageEnumFromBokforderMall(
        row.MALL_TYP_1
      );

      return localUsage.MALL_TYP === translatedValue;
    });

export const certifyOrRetakeAllRows = (
  rows: BokforderType__Associations_Rader[],
  date: string,
  reservID?: string | null
): FormUpdateAssociatonType[][] => {
  const updatedValues: FormUpdateAssociatonType[][] = rows.map(
    (row: BokforderType__Associations_Rader): FormUpdateAssociatonType[] => {
      const newValues: FormUpdateAssociatonType[] = [
        {
          id: row.id,
          associationName: 'Rader',
          operation: row.id.includes(NEWLY_ADDED_ID_PREFIX_FOR_UPDATE)
            ? 'Add_Values'
            : 'Update_Values',
          values: { ATTESTERAD_DATUM: date },
        },
      ];

      if (reservID != undefined || row._Associations?.Reserv?.id != undefined) {
        newValues.push({
          associationName: 'Reserv',
          operation: 'Ref',
          id: date != '' ? reservID ?? row._Associations?.Reserv?.id : null,
        });
      }

      return newValues;
    }
  );

  return updatedValues;
};

export const certifyOrRetakeRows = (
  rows: BokforderType__Associations_Rader[],
  userID: string,
  date: string,
  reservID?: string | null
) => {
  const rowsToAttest = rows.filter(
    (row: BokforderType__Associations_Rader) =>
      row._Associations?.Attestant?.id === userID
  );

  const updatedValues: FormUpdateAssociatonType[][] = rowsToAttest.map(
    (row: BokforderType__Associations_Rader): FormUpdateAssociatonType[] => {
      const newValues: FormUpdateAssociatonType[] = [
        {
          id: row.id,
          associationName: 'Rader',
          operation: row.id.includes(NEWLY_ADDED_ID_PREFIX_FOR_UPDATE)
            ? 'Add_Values'
            : 'Update_Values',
          values: { ATTESTERAD_DATUM: date },
        },
      ];

      if (reservID != undefined || row._Associations?.Reserv?.id != undefined) {
        newValues.push({
          associationName: 'Reserv',
          operation: 'Ref',
          id: date != '' ? reservID ?? row._Associations?.Reserv?.id : null,
        });
      }

      return newValues;
    }
  );

  return updatedValues;
};

const isRowAssocEmpty = (
  radAssoc: BokforderType__Associations_Rader__Associations | null
): boolean => {
  //Loopa igenom assoc och se om det finns åtminstående en entry som har ett värde
  if (radAssoc) {
    for (const [key, value] of Object.entries(radAssoc)) {
      if (
        key !== 'id' &&
        key !== '__typename' &&
        key !== 'Kodplan' &&
        value !== null
      ) {
        return false;
      }
    }
  }
  return true;
};

const getEditableAttributesFromRow = ({
  DEBET,
  KREDIT,
  TEXT,
  _Associations,
}: BokforderType__Associations_Rader) => ({
  DEBET,
  KREDIT,
  TEXT,
  _Associations,
});

export const getEmptyRowIds = (
  rader: BokforderType__Associations_Rader[]
): string[] => {
  const result: string[] = [];

  for (let index = 0; index < rader.length; index++) {
    const row = rader[index];
    let isEmpty = false;

    const changeableValues = getEditableAttributesFromRow(row);

    for (const [key, value] of Object.entries(changeableValues)) {
      if (key === '_Associations') {
        if (isRowAssocEmpty(value)) {
          isEmpty = true;
        } else {
          isEmpty = false;
          break;
        }
      } else if (key === 'TEXT') {
        if (value == null || value === '') {
          isEmpty = true;
        } else {
          isEmpty = false;
          break;
        }
      } else if (value != null) {
        isEmpty = false;
        break;
      } else {
        continue;
      }
    }

    if (isEmpty) {
      result.push(row.id);
    }
  }

  return result;
};

export const getUnfullfilledRowIds = (
  rader: BokforderType__Associations_Rader[]
): string[] => {
  const result: string[] = [];

  for (let index = 0; index < rader.length; index++) {
    const row = rader[index];
    let isEmpty = false;
    let debetOrKreditIsEmpty = false;
    let bothDebetAndKreditIsEmpty = false;

    const changeableValues = getEditableAttributesFromRow(row);

    for (const [key, value] of Object.entries(changeableValues)) {
      if (key === '_Associations') {
        if (isRowAssocEmpty(value)) {
          isEmpty = true;
        } else {
          isEmpty = false;
          break;
        }
      } else if (key === 'DEBET' || key === 'KREDIT') {
        // Denna logiken är väl till för att se om en rad är ofullständig eller ej
        if ((value == null || value === '') && debetOrKreditIsEmpty) {
          bothDebetAndKreditIsEmpty = true;
          isEmpty = true;
        } else if (value == null || value === '') {
          debetOrKreditIsEmpty = true;
        } else {
          isEmpty = false;
        }
      } else if (key === 'TEXT') {
        if (value == null || value === '') {
          isEmpty = true;
        } else {
          isEmpty = false;
          break;
        }
      } else if (value !== null) {
        isEmpty = false;
        break;
      } else {
        continue;
      }
    }

    if (bothDebetAndKreditIsEmpty && !isEmpty) {
      result.push(row.id);
    }
  }

  return result;
};

export const getRowsDeleteObjects = (
  currentValues: IFormData | undefined,
  onlyUnfullfilledRows: boolean,
  includeEmptyRowsIds: boolean
): FormUpdateAssociatonType[][] => {
  let deletedRowsArray: FormUpdateAssociatonType[][] = [];

  if (
    currentValues &&
    currentValues._Associations &&
    currentValues._Associations.Rader
  ) {
    const rows: BokforderType__Associations_Rader[] =
      currentValues._Associations.Rader;

    let idsToRowsToDelete: string[] = [];

    if (onlyUnfullfilledRows) {
      idsToRowsToDelete = idsToRowsToDelete.concat(getUnfullfilledRowIds(rows));
    }

    if (includeEmptyRowsIds) {
      idsToRowsToDelete = idsToRowsToDelete.concat(getEmptyRowIds(rows));
    }

    for (let index = 0; index < idsToRowsToDelete.length; index++) {
      const rowId = idsToRowsToDelete[index];

      const rowRemoveItem: FormUpdateAssociatonType[] = [
        {
          operation: 'Delete_Values',
          associationName: 'Rader',
          id: rowId,
        },
      ];
      deletedRowsArray.push(rowRemoveItem);
    }
  }

  return deletedRowsArray;
};

export const getCertifiedRowsUpdateValues = (
  rows: BokforderType__Associations_Rader[],
  userID: string | null
): FormUpdateAssociatonType[][] => {
  const unfilledRows = getUnfullfilledRowIds(rows);
  //Filtrera bort ofullständiga rader
  const filledRows = rows.filter(row => !unfilledRows.includes(row.id));
  const today = new Date().toLocaleDateString('sv-SE');
  if (rows != null && userID != null) {
    return certifyOrRetakeRows(filledRows, userID ?? '', today);
  }

  return [];
};

export const bfoHasPeriodRows = (
  rows: BokforderQuery_node_TEDEKBokforder__Associations_Rader[]
) => {
  return rows?.some(
    row => row.PERIODISERAD == TEDEKBokforderRadPERIODISERADEnum.JA
  );
};

export const isSendButtonHidden =
  (userID: string, type: TEDEKBokforderTYPEnum) =>
  (editMenuActionParams: IEditMenuActionParams) => {
    const status = editMenuActionParams.businessDataFormContext.data?.STATUS;
    const isBestallare =
      editMenuActionParams.businessDataFormContext.data?._Associations
        ?.Bestallare?.id === userID;

    if (
      type === TEDEKBokforderTYPEnum.UTANORDNING &&
      ((isBestallare &&
        (status === TEDEKBokforderSTATUSEnum.UTKAST ||
          status === TEDEKBokforderSTATUSEnum.EJ_GODKAND)) ||
        editMenuActionParams.businessDataFormContext.isNew)
    ) {
      return false;
    }

    //Kolla på currentValues, är den undefined (vid första renderingen kolla på data istället)
    const attestRows: BokforderType__Associations_Rader[] =
      editMenuActionParams.businessDataFormContext.formState.currentValues?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ??
      editMenuActionParams.businessDataFormContext.data?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ??
      [];

    const isAttestant = attestRows.length > 0;

    if (
      type === TEDEKBokforderTYPEnum.UTANORDNING &&
      ((isBestallare &&
        (status === TEDEKBokforderSTATUSEnum.UTKAST ||
          status === TEDEKBokforderSTATUSEnum.EJ_GODKAND)) ||
        editMenuActionParams.businessDataFormContext.isNew)
    ) {
      return false;
    }

    if (editMenuActionParams.businessDataFormContext.isNew && !isAttestant) {
      return false;
    }

    if (!isBestallare) {
      return true;
    }

    if (isAttestant) {
      return true;
    }

    if (
      status === TEDEKBokforderSTATUSEnum.UTKAST ||
      status === TEDEKBokforderSTATUSEnum.EJ_GODKAND
    ) {
      return !isBestallare;
    } else {
      return isBestallare;
    }
  };

export const isSendAndAttestButtonDisabled = (
  editMenuActionParams: IEditMenuActionParams,
  userID: string | null
): DisabledType => {
  if (userID) {
    //Kolla på currentValues, är den undefined (vid första renderingen kolla på data istället)
    const attestRows: BokforderType__Associations_Rader[] =
      editMenuActionParams.businessDataFormContext.formState.currentValues?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ??
      editMenuActionParams.businessDataFormContext.data?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ??
      [];

    const isAttestant = attestRows.length > 0;

    const haveAttesterat = attestRows.every(
      (row: BokforderType__Associations_Rader) =>
        row.ATTESTERAD_DATUM != undefined
    );

    //Finns inte som attestant på en rad
    if (!isAttestant) {
      return (
        <EDBox key="notSelectedAsAttestant">
          Du är inte vald som attestant
        </EDBox>
      );
    } else if (isAttestant && haveAttesterat) {
      return <EDBox key="alreadyAttesterat">Du har redan attesterat </EDBox>;
    }
  }

  return false;
};

export const isAttestButtonHidden =
  (
    userID: string,
    franvaroReservForData: FranvaroReservForQuery_db_SYSFranvaro_All[]
  ) =>
  (editMenuActionParams: IEditMenuActionParams) => {
    const status = editMenuActionParams.businessDataFormContext.data?.STATUS;

    //Kolla på currentValues, är den undefined (vid första renderingen kolla på data istället)
    const attestRows: BokforderType__Associations_Rader[] =
      editMenuActionParams.businessDataFormContext.formState.currentValues?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ??
      editMenuActionParams.businessDataFormContext.data?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ??
      [];

    const isAttestant = attestRows.length > 0;

    const currentAttestanterWithCurrentUserAsReserv: IFranvaroUserOption[] =
      getAttestanterWithCurrentUserAsReserv(
        editMenuActionParams.businessDataFormContext.formState.currentValues
          ?._Associations?.Rader ?? [],
        franvaroReservForData,
        editMenuActionParams.businessDataFormContext?.data?.TYP
      );

    const oattesteradeAttestanter =
      currentAttestanterWithCurrentUserAsReserv.filter(
        user => !user.Attesterat
      );
    const isReservForSomeone = oattesteradeAttestanter.length > 0;

    const today = new Date();

    const kontrollattestantWithCurrentUserAsReserv = franvaroReservForData.find(
      franvaro =>
        findFranvaroForUser(
          editMenuActionParams.businessDataFormContext.formState.currentValues
            ?._Associations?.Kontrollattestant?.id,
          TEDEKBokforderTYPEnum.UTANORDNING,
          today,
          franvaro
        )
    );

    const isKontrollattestant =
      editMenuActionParams.businessDataFormContext.formState.currentValues
        ?._Associations?.Kontrollattestant?.id === userID;

    const haveKontrollattesterat =
      editMenuActionParams.businessDataFormContext.formState.currentValues
        ?.KONTROLLATTESTERAD_DATUM != null;

    const isReservForKontrollattestant =
      kontrollattestantWithCurrentUserAsReserv != undefined &&
      !haveKontrollattesterat;

    const haveAttesterat = attestRows.every(
      (row: BokforderType__Associations_Rader) =>
        row.ATTESTERAD_DATUM != undefined
    );
    if (
      editMenuActionParams.businessDataFormContext.isNew ||
      (!isAttestant &&
        !isKontrollattestant &&
        !isReservForSomeone &&
        !isReservForKontrollattestant)
    ) {
      return true;
    }

    if (status === TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST) {
      if (isReservForSomeone) {
        return !isReservForSomeone;
      }
      if (isAttestant && !isReservForKontrollattestant) {
        return haveAttesterat;
      }
      if (isKontrollattestant || isReservForKontrollattestant) {
        return haveKontrollattesterat;
      }
    } else {
      return true;
    }

    return true;
  };

export const isSendAndAttestButtonHidden =
  (userID: string) => (editMenuActionParams: IEditMenuActionParams) => {
    const status = editMenuActionParams.businessDataFormContext.data?.STATUS;

    //Kolla på currentValues, är den undefined (vid första renderingen kolla på .data istället)
    const attestRows: BokforderType__Associations_Rader[] =
      editMenuActionParams.businessDataFormContext.formState.currentValues?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ??
      editMenuActionParams.businessDataFormContext.data?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ??
      [];

    const isAttestant = attestRows.length > 0;

    const isBestallare =
      editMenuActionParams.businessDataFormContext.data?._Associations
        ?.Bestallare?.id === userID;

    if (editMenuActionParams.businessDataFormContext.isNew && isAttestant) {
      return false;
    }

    if (!isBestallare || !isAttestant) {
      return true;
    }

    if (
      status === TEDEKBokforderSTATUSEnum.UTKAST ||
      status === TEDEKBokforderSTATUSEnum.EJ_GODKAND
    ) {
      return !isBestallare;
    } else {
      return isBestallare;
    }
  };

export const isRetakeButtonHidden =
  (
    userID: string,
    franvaroReservForData: FranvaroReservForQuery_db_SYSFranvaro_All[]
  ) =>
  (editMenuActionParams: IEditMenuActionParams) => {
    if (editMenuActionParams.businessDataFormContext.isNew) {
      return true;
    }

    const status = editMenuActionParams.businessDataFormContext.data?.STATUS;
    const isBestallare =
      editMenuActionParams.businessDataFormContext.data?._Associations
        ?.Bestallare?.id === userID;

    const attestRows: BokforderType__Associations_Rader[] =
      editMenuActionParams.businessDataFormContext.data?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ?? [];

    const isAttestant = attestRows.length > 0;

    const haveAttesterat = attestRows.every(
      (row: BokforderType__Associations_Rader) =>
        row.ATTESTERAD_DATUM != undefined
    );

    const currentAttestanterWithCurrentUserAsReserv: IFranvaroUserOption[] =
      getAttestanterWithCurrentUserAsReserv(
        editMenuActionParams.businessDataFormContext?.formState.currentValues
          ?._Associations?.Rader ?? [],
        franvaroReservForData,
        editMenuActionParams.businessDataFormContext?.data?.TYP
      );

    const attesteradeAttestanter =
      currentAttestanterWithCurrentUserAsReserv.filter(
        user => user.Attesterat && user.AttesteratAsCurrentReserv
      );
    const someoneHasAttesterat =
      editMenuActionParams.businessDataFormContext?.formState.currentValues?._Associations?.Rader?.some(
        (row: any) => row?.ATTESTERAD_DATUM != null
      );

    const isKontrollattestant =
      editMenuActionParams.businessDataFormContext.data?._Associations
        ?.Kontrollattestant?.id === userID;

    const isKontrollattesterad =
      editMenuActionParams.businessDataFormContext.data
        ?.KONTROLLATTESTERAD_DATUM != null;

    const today = new Date();

    const kontrollattestantWithCurrentUserAsReserv = franvaroReservForData.find(
      franvaro =>
        findFranvaroForUser(
          editMenuActionParams.businessDataFormContext.formState.currentValues
            ?._Associations?.Kontrollattestant?.id,
          TEDEKBokforderTYPEnum.UTANORDNING,
          today,
          franvaro
        )
    );

    const isReservForKontrollattestant =
      kontrollattestantWithCurrentUserAsReserv?._Associations?.Reserv?.id ===
      editMenuActionParams.businessDataFormContext.data?._Associations
        ?.ReservKontrollattestant?.id;

    const haveBokfVer =
      editMenuActionParams.businessDataFormContext.data?._Associations?.Bokfver
        ?.id != null;

    const verCreated =
      editMenuActionParams.businessDataFormContext.data?.VER_SKAPAD_DATUM !=
      null;
    switch (status) {
      case TEDEKBokforderSTATUSEnum.UTKAST:
      case TEDEKBokforderSTATUSEnum.EJ_GODKAND:
        return isBestallare;

      case TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST: {
        if (
          isBestallare &&
          !isAttestant &&
          attesteradeAttestanter.length === 0
        ) {
          return someoneHasAttesterat;
        }

        if (
          isAttestant &&
          !isBestallare &&
          attesteradeAttestanter.length === 0
        ) {
          return !haveAttesterat;
        }

        if (attesteradeAttestanter.length > 0) {
          return false;
        }

        if (
          isBestallare &&
          (isAttestant || attesteradeAttestanter.length > 0)
        ) {
          return (
            someoneHasAttesterat &&
            haveAttesterat &&
            attesteradeAttestanter.length > 0
          );
        }

        return true;
      }

      case TEDEKBokforderSTATUSEnum.ATTESTERAD: {
        if (
          (isKontrollattestant || isReservForKontrollattestant) &&
          isKontrollattesterad
        ) {
          return haveBokfVer || verCreated;
        }
        return (
          !isAttestant && !haveAttesterat && attesteradeAttestanter.length === 0
        );
      }

      default:
        return isBestallare;
    }
  };

export const isRetakeButtonDisabled =
  (
    userID: string,
    franvaroReservForData: FranvaroReservForQuery_db_SYSFranvaro_All[]
  ) =>
  (editMenuActionParams: IEditMenuActionParams) => {
    if (editMenuActionParams.businessDataFormContext.isNew) {
      return true;
    }

    if (editMenuActionParams.businessDataFormContext.formState.formHasChanged) {
      return 'Det finns ändringar som inte är sparade';
    }

    const status = editMenuActionParams.businessDataFormContext.data?.STATUS;
    const isBestallare =
      editMenuActionParams.businessDataFormContext.data?._Associations
        ?.Bestallare?.id === userID;

    const allAttestRows =
      editMenuActionParams.businessDataFormContext.data?._Associations?.Rader ??
      [];

    const attestRows: BokforderType__Associations_Rader[] =
      allAttestRows.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ?? [];

    const someoneHasAttesterat = allAttestRows.some(
      (row: BokforderType__Associations_Rader) =>
        row.ATTESTERAD_DATUM != undefined
    );

    const isAttestant = attestRows.length > 0;

    const currentAttestanterWithCurrentUserAsReserv: IFranvaroUserOption[] =
      getAttestanterWithCurrentUserAsReserv(
        editMenuActionParams.businessDataFormContext?.formState.currentValues
          ?._Associations?.Rader ?? [],
        franvaroReservForData,
        editMenuActionParams.businessDataFormContext?.data?.TYP
      );

    const attesteradeAttestanter =
      currentAttestanterWithCurrentUserAsReserv.filter(
        user => user.Attesterat && user.AttesteratAsCurrentReserv
      );

    const isKontrollattestant =
      editMenuActionParams.businessDataFormContext.data?._Associations
        ?.Kontrollattestant?.id === userID;

    const isKontrollattesterad =
      editMenuActionParams.businessDataFormContext.data
        ?.KONTROLLATTESTERAD_DATUM != null;

    const today = new Date();

    const kontrollattestantWithCurrentUserAsReserv = franvaroReservForData.find(
      franvaro =>
        findFranvaroForUser(
          editMenuActionParams.businessDataFormContext.formState.currentValues
            ?._Associations?.Kontrollattestant?.id,
          TEDEKBokforderTYPEnum.UTANORDNING,
          today,
          franvaro
        )
    );

    const isReservForKontrollattestant =
      kontrollattestantWithCurrentUserAsReserv?._Associations?.Reserv?.id ===
      editMenuActionParams.businessDataFormContext.data?._Associations
        ?.ReservKontrollattestant?.id;

    const haveAttesterat = attestRows.every(
      (row: BokforderType__Associations_Rader) =>
        row.ATTESTERAD_DATUM != undefined
    );

    const haveBokfVer =
      editMenuActionParams.businessDataFormContext.data?._Associations?.Bokfver
        ?.id != null;

    const verCreated =
      editMenuActionParams.businessDataFormContext.data?.VER_SKAPAD_DATUM !=
      null;

    switch (status) {
      case TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST:
        return isBestallare &&
          !isAttestant &&
          attesteradeAttestanter.length === 0
          ? someoneHasAttesterat
            ? 'Bokföringsordern har attesterats av någon attestant'
            : false
          : (isAttestant && haveAttesterat) || attesteradeAttestanter.length > 0
          ? false
          : isBestallare && !someoneHasAttesterat
          ? false
          : true;

      case TEDEKBokforderSTATUSEnum.ATTESTERAD:
        return haveBokfVer || verCreated
          ? 'Kan inte återta en Bokföringsorder efter en verifikation har skapats'
          : (isAttestant && haveAttesterat && !isKontrollattesterad) ||
            (attesteradeAttestanter.length > 0 && !isKontrollattesterad) ||
            ((isKontrollattestant || isReservForKontrollattestant) &&
              isKontrollattesterad)
          ? false
          : isKontrollattesterad &&
            (isAttestant || attesteradeAttestanter.length > 0)
          ? 'Bokföringsordern har kontrollattesterats'
          : true;
      case TEDEKBokforderSTATUSEnum.VERIFIKATION_SKAPAD:
        return 'Kan inte återta en Bokföringsorder efter en verifikation har skapats';

      default:
        return (
          isBestallare ||
          isAttestant ||
          isKontrollattestant ||
          isReservForKontrollattestant
        );
    }
  };

export const isSaveButtonDisabled = (
  params: IEditMenuActionParams,
  bokforderStatus: TEDEKBokforderSTATUSEnum | undefined
): boolean | DisabledType => {
  return (
    !params.businessDataFormContext.formState.formHasChanged ||
    params.businessDataFormContext.formState.loading ||
    params.businessDataFormContext.mutationLoading ||
    (bokforderStatus === TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST &&
      getBfoValidationErrors(params))
  );
};

export const isSendbackButtonDisabled =
  (userID: string | null) =>
  (editMenuActionParams: IEditMenuActionParams): string | undefined => {
    const allAttestRows =
      editMenuActionParams.businessDataFormContext.formState.currentValues
        ?._Associations?.Rader ?? [];
    const everyRowAttesterad = allAttestRows.every(
      (row: BokforderType__Associations_Rader) =>
        row.ATTESTERAD_DATUM != undefined
    );

    const isKontrollattestant =
      editMenuActionParams.businessDataFormContext.formState.currentValues
        ?._Associations?.Kontrollattestant?.id === userID;

    if (isKontrollattestant && !everyRowAttesterad) {
      return 'Det finns attestanter som inte har attesterat sina rader';
    }
    return undefined;
  };

export const isAttestButtonDisabled =
  (
    userID: string,
    franvaroReservForData: FranvaroReservForQuery_db_SYSFranvaro_All[]
  ) =>
  (editMenuActionParams: IEditMenuActionParams) => {
    const status = editMenuActionParams.businessDataFormContext.data?.STATUS;

    const allAttestRows =
      editMenuActionParams.businessDataFormContext.formState.currentValues
        ?._Associations?.Rader ?? [];

    const isKontrollattestant =
      editMenuActionParams.businessDataFormContext.formState.currentValues
        ?._Associations?.Kontrollattestant?.id === userID;

    const today = new Date();

    const kontrollattestantWithCurrentUserAsReserv = franvaroReservForData.find(
      franvaro =>
        findFranvaroForUser(
          editMenuActionParams.businessDataFormContext.formState.currentValues
            ?._Associations?.Kontrollattestant?.id,
          TEDEKBokforderTYPEnum.UTANORDNING,
          today,
          franvaro
        )
    );

    const haveKontrollattesterat =
      editMenuActionParams.businessDataFormContext.formState.currentValues
        ?.KONTROLLATTESTERAD_DATUM != null;

    const isReservForKontrollattestant =
      kontrollattestantWithCurrentUserAsReserv != undefined &&
      !haveKontrollattesterat;

    const everyRowAttesterad = allAttestRows.every(
      (row: BokforderType__Associations_Rader) =>
        row.ATTESTERAD_DATUM != undefined
    );

    const attestRows: BokforderType__Associations_Rader[] =
      allAttestRows.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ?? [];

    const isAttestant = attestRows.length > 0;

    const haveAttesterat = attestRows.every(
      row => row.ATTESTERAD_DATUM != null
    );

    const currentAttestanterWithCurrentUserAsReserv: IFranvaroUserOption[] =
      getAttestanterWithCurrentUserAsReserv(
        editMenuActionParams.businessDataFormContext?.formState.currentValues
          ?._Associations?.Rader ?? [],
        franvaroReservForData,
        editMenuActionParams.businessDataFormContext?.data?.TYP
      );

    const notAttesteradeAttestanter =
      currentAttestanterWithCurrentUserAsReserv.filter(
        user => !user.Attesterat
      );

    const isReservForSomeone = notAttesteradeAttestanter.length > 0;

    switch (status) {
      case TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST: {
        if (isKontrollattestant || isReservForKontrollattestant) {
          if ((isAttestant && !haveAttesterat) || isReservForSomeone) {
            return false;
          }
          if (everyRowAttesterad && !haveKontrollattesterat) {
            return isAttestant || isReservForSomeone;
          } else {
            return 'Det finns attestanter som inte har attesterat sina rader';
          }
        } else if (isAttestant || isReservForSomeone) {
          return haveAttesterat && !isReservForSomeone;
        }
        return !(
          isAttestant ||
          isReservForSomeone ||
          isKontrollattestant ||
          isReservForKontrollattestant
        );
      }

      default:
        return (
          isAttestant ||
          isReservForSomeone ||
          isKontrollattestant ||
          isReservForKontrollattestant
        );
    }
  };

/**
 * Takes an array of reserves and returns the names of all reserves in a string list
 * @param {BokforderType__Associations_Rader__Associations_Attestant__Associations_Franvaro_All[] | null | undefined} franvaroList A list of reserves for any given certifier
 * @param {TEDEKBokforderTYPEnum | null | undefined} type The type for the current Bokföringsordern
 * @returns {string[]} A list of reserves names based on the array given, returns an empty array if no valid options exists
 */
export const getReservNamesBasedOnFranvaroList = (
  franvaroList:
    | BokforderType__Associations_Rader__Associations_Attestant__Associations_Franvaro_All[]
    | null
    | undefined,
  type: TEDEKBokforderTYPEnum | null | undefined
): string[] => {
  const reservList =
    franvaroList?.reduce((reservNameList, franvaro) => {
      const today = new Date();
      const isForUtanordning = Boolean(franvaro?.FOR_UTANORDNING);
      const isForBokforder = Boolean(franvaro?.FOR_BOKFORDER);

      const franvaroIsForType =
        type === TEDEKBokforderTYPEnum.BOKFORINGSORDER
          ? isForBokforder
          : type === TEDEKBokforderTYPEnum.UTANORDNING
          ? isForUtanordning
          : false;

      const includeReserv =
        new Date(franvaro.DATUM_FROM) <= today &&
        new Date(franvaro.TomDatum) >= today &&
        franvaroIsForType;

      if (
        franvaro._Associations?.Reserv?.Name &&
        !reservNameList.includes(franvaro._Associations?.Reserv?.Name ?? '') &&
        includeReserv
      ) {
        return [...reservNameList, franvaro._Associations?.Reserv?.Name];
      }

      return reservNameList;
    }, [] as string[]) ?? [];

  return reservList;
};

export const getAttestantStrings = (
  rows: BokforderType__Associations_Rader[],
  type: TEDEKBokforderTYPEnum | null | undefined
) => {
  if (rows.length === 0) {
    return [' — '];
  }

  const attestanter = rows.reduce((attestantObjectList, row) => {
    if (
      !attestantObjectList?.some(
        attestantObject =>
          attestantObject.Attestant === row._Associations?.Attestant?.Name
      ) &&
      row._Associations?.Attestant != null
    ) {
      const reservList = getReservNamesBasedOnFranvaroList(
        row._Associations?.Attestant?._Associations?.Franvaro_All,
        type
      );
      return [
        ...attestantObjectList,
        {
          Attestant: row._Associations?.Attestant?.Name,
          ReservList: reservList,
          Reserv: row._Associations?.Reserv?.Name,
          DATUM: row.ATTESTERAD_DATUM,
        },
      ];
    }

    return attestantObjectList;
  }, [] as IGetAttestantStringObject[]);

  if (attestanter.length === 0) {
    return [' — '];
  }

  return attestanter.map((row, index) => {
    let attestantText = '';

    const reservString =
      row.ReservList.length > 0
        ? ` (Reserv: ${row.ReservList.join(', ')})`
        : '';

    const attesteradByText =
      row.DATUM !== '' && row.DATUM != null
        ? row.Reserv != null
          ? ` (Attesterad ${row.DATUM} av reserv ${row.Reserv})`
          : ` (Attesterad ${row.DATUM})`
        : '';

    attestantText = `${row.Attestant}${
      attesteradByText != '' ? attesteradByText : reservString
    }`;
    if (attestanter.length > 1 && index !== attestanter.length - 1) {
      attestantText += ', ';
    }

    return attestantText;
  });
};

export const createUserWithKodbehorigheter = (
  user: UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter,
  avenyCollectionMap: AvenyCollectionMap
) => {
  const bokforderKodbehorighetUrval: IBokforderKodbehorigheter[] | undefined =
    user.bokforderkodbehorigheter?.map(bokforderKodbeh => {
      const selection =
        bokforderKodbeh?.kodbehorighetSelection as NodeUrvalQuery_node_TEDSelection;

      const bokforderKodbehorighetUrval: IBokforderKodbehorigheter = {
        urval: convertUrval(
          selection,
          EK_KONTO_URVAL_COLLECTION_NAME,
          avenyCollectionMap
        ),
        kodplanID: bokforderKodbeh?.kodplanID,
        FOR_BOKFORDER: bokforderKodbeh?.FOR_BOKFORDER,
        FOR_UTANORDNING: bokforderKodbeh?.FOR_UTANORDNING,
        UTANORDNING_KONTROLL: bokforderKodbeh?.UTANORDNING_KONTROLL,
        UTANORDNING_KA_MAXBELOPP: bokforderKodbeh?.UTANORDNING_KA_MAXBELOPP,
        UTANORDNING_KONTROLLBELOPP: bokforderKodbeh?.UTANORDNING_KONTROLLBELOPP,
      };
      return bokforderKodbehorighetUrval;
    });

  const userWithKodbehorigheter: IUserBokforderKodbehorigheter = {
    bokforderKodbehorighetUrval: bokforderKodbehorighetUrval ?? [],
    ...user,
  };

  return userWithKodbehorigheter;
};

export const createUsersWithKodbehorigheter = (
  allUsers: UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter[],
  avenyCollectionMap: AvenyCollectionMap
): IUserBokforderKodbehorigheter[] => {
  const result: IUserBokforderKodbehorigheter[] = [];
  for (let index = 0; index < allUsers.length; index++) {
    const user = allUsers[index];

    const userWithKodbehorigheter = createUserWithKodbehorigheter(
      user,
      avenyCollectionMap
    );

    result.push(userWithKodbehorigheter);
  }

  return result;
};

export const sortByOrdningsNr = (
  a: { ORDNINGS_NR: number | null },
  b: { ORDNINGS_NR: number | null }
) => {
  if (a?.ORDNINGS_NR && b?.ORDNINGS_NR) {
    return numberCompare(a.ORDNINGS_NR, b.ORDNINGS_NR);
  } else {
    return 0;
  }
};

export const getDiffBetweenKreditDebet = (
  rows: BokforderType__Associations_Rader[]
) => {
  let sumDebet = 0;
  let sumKredit = 0;
  for (let index = 0; index < rows.length; index++) {
    const row = rows[index];
    if (row.DEBET && row.KREDIT == null) {
      sumDebet += row.DEBET;
    } else if (row.KREDIT && row.DEBET == null) {
      sumKredit += row.KREDIT;
    } else if (row.DEBET == null && row.KREDIT == null) {
      continue;
    } else {
      sumDebet += row.DEBET ?? 0;
      sumKredit += row.KREDIT ?? 0;
    }
  }

  return roundToTwoDecimals(sumKredit - sumDebet);
};

export const getValuesForNewBokforder = (
  status: TEDEKBokforderSTATUSEnum,
  bokfOrderGruppID: string | undefined,
  userID: string | null,
  utbetalningsKategori: TEDEKBokforderU_UTBETALNINGSKATEGORIEnum | null,
  updateBestalldatum?: boolean,
  type?: TEDEKBokforderTYPEnum
): FormUpdateAssociatonType[][] => {
  const date = new Date().toLocaleDateString('sv-SE');

  let ownFieldsUpdate: FormUpdateAssociatonType = {
    operation: 'OwnFields',
    values: {
      STATUS: status,
      STATUS_DATUM: date,
      TYP: type,
      U_UTBETALNINGSKATEGORI: utbetalningsKategori,
    },
  };

  if (updateBestalldatum != null && updateBestalldatum === true) {
    // Lägg på beställd_datum
    ownFieldsUpdate = {
      ...ownFieldsUpdate,
      values: { ...ownFieldsUpdate.values, BESTALLD_DATUM: date },
    };
  }

  return [
    [
      ownFieldsUpdate,
      {
        associationName: 'Bokfgrupp',
        operation: 'Ref',
        id: bokfOrderGruppID ?? '',
        values: {
          id: bokfOrderGruppID ?? '',
        },
      },
    ],
    [
      {
        associationName: 'Bestallare',
        operation: 'Ref',
        id: userID,
      },
    ],
  ];
};

export const translateBokforderTypeToOmforingsType = (
  value: TEDEKBokforderVariantEnum
): TEDEKBokforderOMFORINGSTYPEnum => {
  switch (value) {
    case TEDEKBokforderVariantEnum.VAND:
      return TEDEKBokforderOMFORINGSTYPEnum.VAND;

    case TEDEKBokforderVariantEnum.OMBOKFOR:
      return TEDEKBokforderOMFORINGSTYPEnum.OMBOKFOR;

    case TEDEKBokforderVariantEnum.PERIODISERA:
      return TEDEKBokforderOMFORINGSTYPEnum.PERIODISERA;

    case TEDEKBokforderVariantEnum.KOPIERA:
      return TEDEKBokforderOMFORINGSTYPEnum.KOPIERA;

    default:
      return TEDEKBokforderOMFORINGSTYPEnum.UNDEFINED;
  }
};

export const translateTEDEKBokforderVariantToUtbetalningskategori = (
  variant: TEDEKBokforderVariantEnum | DefaultBfoVariantEnum | null | undefined
): TEDEKBokforderU_UTBETALNINGSKATEGORIEnum | null => {
  switch (variant) {
    case TEDEKBokforderVariantEnum.UTANORDINGBANKONTO:
      return TEDEKBokforderU_UTBETALNINGSKATEGORIEnum.BANKKONTO;
    case TEDEKBokforderVariantEnum.UTANORDINGKONTANT:
      return TEDEKBokforderU_UTBETALNINGSKATEGORIEnum.KONTANT;
    case TEDEKBokforderVariantEnum.UTANORDINGPGBG:
      return TEDEKBokforderU_UTBETALNINGSKATEGORIEnum.PGBG;
    case TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO:
      return TEDEKBokforderU_UTBETALNINGSKATEGORIEnum.TILLOGODO;

    default:
      return null;
  }
};

export const translateOmforingsTypeToBokforderVariant = (
  value: TEDEKBokforderOMFORINGSTYPEnum
): TEDEKBokforderVariantEnum | null => {
  switch (value) {
    case TEDEKBokforderOMFORINGSTYPEnum.VAND:
      return TEDEKBokforderVariantEnum.VAND;
    case TEDEKBokforderOMFORINGSTYPEnum.PERIODISERA:
      return TEDEKBokforderVariantEnum.PERIODISERA;
    case TEDEKBokforderOMFORINGSTYPEnum.OMBOKFOR:
      return TEDEKBokforderVariantEnum.OMBOKFOR;
    case TEDEKBokforderOMFORINGSTYPEnum.KOPIERA:
      return TEDEKBokforderVariantEnum.KOPIERA;
    default:
      return null;
  }
};

export const hasValidationErrors = (
  editMenuActionParams: IEditMenuActionParams
): JSX.Element[] | undefined => {
  const validationErrors =
    editMenuActionParams.businessDataFormContext.formState.validation;
  let disabledReason: DisabledType = undefined;

  if (validationErrors && validationErrors.length > 0) {
    disabledReason = validationErrors
      .filter(
        validation =>
          validation.type === 'Error' || validation.type === 'RequiredValueHint'
      )
      .map(validation => {
        if (
          validation.type === 'RequiredValueHint' &&
          validation.message == undefined
        ) {
          return (
            //Key kan ha samma värde eftersom vi filterar bort värden med uniq()
            <EDBox key="RequiredValueHint">Obligatoriska värden krävs</EDBox>
          );
        } else {
          return <EDBox key={validation.fieldName}>{validation.message}</EDBox>;
        }
      });
  }

  const result = Array.isArray(disabledReason)
    ? disabledReason.length > 0
      ? uniq(disabledReason)
      : undefined
    : disabledReason;

  return result;
};

export const getBfoValidationErrors = (
  editMenuActionParams: IEditMenuActionParams
): DisabledType => {
  let result: JSX.Element[] = [];

  const validationErrors = hasValidationErrors(editMenuActionParams);

  if (validationErrors) {
    result = [...result, ...validationErrors];
  }

  if (result.length > 0) {
    return result;
  } else {
    return undefined;
  }
};

export const isPeriodiseringDisabled = (
  verkatKod: string | TEDEKBokfverVERKAT_KODEnum
) => {
  let result = true;

  switch (verkatKod) {
    case TEDEKBokfverVERKAT_KODEnum.EK_VERIFIKATIONSREGISTRERING:
      result = false;
      break;
    case TEDEKBokfverVERKAT_KODEnum.LR_DEFINITIVBOKNING:
      result = false;
      break;
    case TEDEKBokfverVERKAT_KODEnum.WEK_BOKFORINGSORDER:
      result = false;
      break;
    default:
      result = true;
      break;
  }
  return result;
};

export const getBokforderTypeFromSearchParams = (
  search: string
): TEDEKBokforderTYPEnum | null => {
  const searchParamsTypeValue = new URLSearchParams(search).get('type');
  return searchParamsTypeValue
    ? TEDEKBokforderTYPEnum[
        searchParamsTypeValue as keyof typeof TEDEKBokforderTYPEnum
      ]
    : null;
};

export const getBokforderVariantFromSearchParams = (
  search: string
): TEDEKBokforderVariantEnum | DefaultBfoVariantEnum | null => {
  const searchParamsVariantValue = new URLSearchParams(search).get('variant');

  return searchParamsVariantValue
    ? TEDEKBokforderVariantEnum[
        searchParamsVariantValue as keyof typeof TEDEKBokforderVariantEnum
      ]
      ? TEDEKBokforderVariantEnum[
          searchParamsVariantValue as keyof typeof TEDEKBokforderVariantEnum
        ]
      : DefaultBfoVariantEnum[
          searchParamsVariantValue as keyof typeof DefaultBfoVariantEnum
        ]
    : null;
};

export const getBokforderCopyIDFromSearchParams = (
  search: string
): string | null => {
  const searchParamsCopyIDValue = new URLSearchParams(search).get('copyID');
  return searchParamsCopyIDValue;
};

export const saveRows = (
  params: IEditMenuActionParams,
  updateValues: FormUpdateAssociatonType[][]
) => {
  const mergedValues = mergeBusinessDataMutations(
    params.businessDataFormContext.formState.values ?? {},
    getFormUpdateValue(updateValues, params.businessDataFormContext.data ?? {})
  );
  params.businessDataFormContext.saveForm(
    mergedValues,
    () => {
      params.selectDetail?.(null, true);
    },
    undefined,
    { suppressAddedIdSelection: true }
  );
};

/**
 * Checks if a franvaro is for current user
 * @param {string | undefined} userID ID for the user whom you are getting reservers for
 * @param {TEDEKBokforderTYPEnum | null | undefined} type The type for the current Bokföringsordern
 * @param {Date} today Today´s date
 * @param {FranvaroReservForQuery_db_SYSFranvaro_All} franvaro Franvaro to check
 * @returns {boolean} Boolean to decide if current franvaro is valid for inputed user
 */
export const findFranvaroForUser = (
  userID: string | undefined,
  type: TEDEKBokforderTYPEnum | null | undefined,
  today: Date,
  franvaro: FranvaroReservForQuery_db_SYSFranvaro_All
): boolean => {
  const tomDate = new Date(new Date(franvaro?.TomDatum).setHours(23, 59, 59));
  const fromDate = new Date(franvaro?.DATUM_FROM);

  const isInDateInterval = inDateInterval(fromDate, tomDate, today);

  const isForUtanordning = Boolean(franvaro?.FOR_UTANORDNING);
  const isForBokforder = Boolean(franvaro?.FOR_BOKFORDER);

  const franvaroIsForType =
    type === TEDEKBokforderTYPEnum.BOKFORINGSORDER
      ? isForBokforder
      : type === TEDEKBokforderTYPEnum.UTANORDNING
      ? isForUtanordning
      : false;

  return (
    franvaro._Associations?.Anvandare?.id === userID &&
    isInDateInterval &&
    franvaroIsForType
  );
};

/**
 * Gets certifiers with current user as their reserve certifier
 * @param {BokforderType__Associations_Rader[]} rows Rows on the current Bokföringsorder
 * @param {FranvaroReservForQuery_db_SYSFranvaro_All[]} franvaroReservForData Reserve data based on current user as reserve
 * @param {TEDEKBokforderTYPEnum | null | undefined} type The type for the current Bokföringsordern
 * @returns {IFranvaroUserOption[]} An array of users with current user as reserve
 */
export const getAttestanterWithCurrentUserAsReserv = (
  rows: BokforderType__Associations_Rader[],
  franvaroReservForData: FranvaroReservForQuery_db_SYSFranvaro_All[],
  type: TEDEKBokforderTYPEnum | null | undefined
): IFranvaroUserOption[] => {
  if (!rows || !Array.isArray(rows)) {
    return [];
  }
  const today = new Date();
  const currentAttestanterWithMeAsReserv = rows.reduce(
    (prevValue, currentRow) => {
      const franvaro = franvaroReservForData.find(franvaro =>
        findFranvaroForUser(
          currentRow._Associations?.Attestant?.id,
          type,
          today,
          franvaro
        )
      );

      if (franvaro && franvaro._Associations?.Anvandare) {
        const newUserOption: IFranvaroUserOption = {
          id: franvaro._Associations?.Anvandare.id,
          Fullname: franvaro._Associations?.Anvandare.Name,
          SIGNATURE: franvaro._Associations?.Anvandare.SIGNATURE,
          Attesterat: currentRow.ATTESTERAD_DATUM != null,
          AttesteratAsCurrentReserv:
            currentRow._Associations?.Reserv?.id ===
            franvaro._Associations?.Reserv?.id,
        };
        if (prevValue.some(user => user.id === newUserOption.id)) {
          return prevValue;
        }
        return [...prevValue, newUserOption];
      }

      return prevValue;
    },
    [] as IFranvaroUserOption[]
  );

  return currentAttestanterWithMeAsReserv;
};
